import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { Button, Collapse, Radio } from 'antd'
import { WeekScheduleEditor, WeekScheduleRow } from '../../../components/WeekScheduleEditor'
import warehouseScheduleController from './warehouseSchedule.controller'
import { openApi } from '../../../helpers/request'
import i from '../../../translations/i'

// Настройка графика по конкретному складу — если для склада не задано ни одной
// строки, используется глобальный график (см. Options-раздел выше). Список свёрнут
// по умолчанию (складов может быть много) — в заголовке видно текущее состояние.
export const WarehouseScheduleSection = observer(() => {

  const [warehouses, setWarehouses] = useState<any[]>([])

  useEffect(() => {
    warehouseScheduleController.get()
    openApi('get', '/data_data')
      .then((result: any) => setWarehouses(result.data?.warehouses ?? []))
      .catch(error => console.log(error.response))
  }, [])

  if(!warehouseScheduleController.render)
    return <></>

  return (
    <Collapse
      items={warehouses.map((warehouse: any) => ({
        key: warehouse.id,
        label: <WarehouseScheduleSummary warehouse={warehouse} />,
        children: <WarehouseScheduleEditorPanel warehouse={warehouse} />,
      }))}
    />
  )
})

const WarehouseScheduleSummary = observer(({ warehouse }: { warehouse: any }) => {

  const rows = warehouseScheduleController.rowsFor(warehouse.id)

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', gap: 12 }}>
      <span>{warehouse.name}</span>
      <span style={{ fontSize: 12, color: rows.length > 0 ? 'var(--primary-color)' : 'var(--text-muted-color)' }}>
        {rows.length > 0 ? i.t('settings:order.scheduleCustomDays', { count: rows.length }) : i.t('settings:order.scheduleUsesGlobal')}
      </span>
    </div>
  )
})

const WarehouseScheduleEditorPanel = observer(({ warehouse }: { warehouse: any }) => {

  const [rows, setRows] = useState<WeekScheduleRow[]>(() => warehouseScheduleController.rowsFor(warehouse.id))
  const [allowPreorders, setAllowPreorders] = useState<boolean | null>(() => warehouseScheduleController.preordersFor(warehouse.id))
  const [saving, setSaving] = useState(false)

  const handleSave = () => {
    setSaving(true)
    warehouseScheduleController.save(warehouse.id, rows, allowPreorders).finally(() => setSaving(false))
  }

  return (
    <>
      <WeekScheduleEditor rows={rows} onChange={setRows} />

      <div style={{ marginTop: 8, fontSize: 12, opacity: 0.65 }}>
        {warehouse.timezone
          ? i.t('settings:order.warehouseScheduleTimezone', { timezone: warehouse.timezone })
          : i.t('settings:order.warehouseScheduleTimezoneProject')}
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginTop: 12 }}>
        <span>{i.t('settings:order.warehousePreordersLabel')}</span>
        <Radio.Group
          size="small"
          value={allowPreorders === null ? 'default' : (allowPreorders ? 'on' : 'off')}
          onChange={e => setAllowPreorders(e.target.value === 'default' ? null : e.target.value === 'on')}
        >
          <Radio.Button value="default">{i.t('settings:order.warehousePreordersDefault')}</Radio.Button>
          <Radio.Button value="on">{i.t('settings:order.warehousePreordersEnabled')}</Radio.Button>
          <Radio.Button value="off">{i.t('settings:order.warehousePreordersDisabled')}</Radio.Button>
        </Radio.Group>
      </div>

      <Button style={{ marginTop: 8 }} size="small" type="primary" loading={saving} onClick={handleSave}>
        {i.t('def:actions.save')}
      </Button>
    </>
  )
})
